import { h } from 'preact'
export const IconClose = () => {
    return (
			<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.06055 16.06055">
				<g id="Layer_1-2">
					<polygon points="16.06055 1.06055 15 0 8.03027 6.96973 1.06055 0 0 1.06055 6.96973 8.03027 0 15 1.06055 16.06055 8.03027 9.09082 15 16.06055 16.06055 15 9.09082 8.03027 16.06055 1.06055" />
				</g>
			</svg>
		);
}
